<script lang="tsx">
import { defineComponentBaseUiFormCheckbox } from '@core/app/components/base/ui/form/BaseUiFormCheckbox.vue'

export default defineComponentBaseUiFormCheckbox()

</script>

<style lang="scss" scoped>
@use "@core-scss/components/BaseUiFormCheckbox" as *;

@include container {
    gap: 0.875rem;
}

</style>
